<template>
  <div class="description-browser">
    <div class="header">
      <h2>{{ t(isSelectionMode ? 'excel.browser.selectTitle' : 'excel.browser.title') }}</h2>
      <p>{{ props.descricao }}</p>
      <el-button 
        type="primary"
        @click="toggleMode"
      >
        {{ t(isSelectionMode ? 'excel.browser.viewHistory' : 'excel.browser.selectMode') }} 
      </el-button>
    </div>
    
    <div v-if="isSelectionMode" class="description-select-container">
      <el-select
        v-model="currentDescription"
        filterable
        clearable
        class="description-select"
        :placeholder="t('excel.fields.selectDescription')"
      >
        <el-option
          v-for="desc in descriptions"
          :key="desc"
          :label="desc"
          :value="desc"
        />
      </el-select>
    </div>

    <excel-entry-history 
      v-else
      :descricao="currentDescription"
      v-if="currentDescription"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import axios from 'axios'
import { useAuthStore } from '../stores/auth'
import { useI18n } from 'vue-i18n'
import ExcelEntryHistory from './ExcelEntryHistory.vue'
import Swal from 'sweetalert2'

const props = defineProps<{
  descricao?: string
}>()

const { t } = useI18n()
const authStore = useAuthStore()

const descriptions = ref<string[]>([])
const selectedDescription = ref<string>(props.descricao ? decodeURIComponent(props.descricao) : '')
const currentDescription = computed({
  get: () => selectedDescription.value || (props.descricao ? decodeURIComponent(props.descricao) : '') || '',
  set: (value: string) => {
    selectedDescription.value = value
    if (value) {
      isSelectionMode.value = false
    }
  }
})
const isSelectionMode = ref(!props.descricao)

const toggleMode = () => {
  isSelectionMode.value = !isSelectionMode.value
}

const api = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + authStore.keycloak?.token
  }
})

const fetchDescriptions = async () => {
  try {
    const response = await api.get<string[]>(
      `${import.meta.env.VITE_EXCEL_API_URL}/excel/descricoes`
    )
    descriptions.value = response.data
    Swal.fire({
      title: 'Success',
      text: 'Descriptions fetched successfully (' + response.data.length + ')',
      icon: 'success'
    })
  } catch (err) {
    console.error('Failed to fetch descriptions:', err)
    Swal.fire({
      title: 'Error',
      text: 'Failed to fetch descriptions',
      icon: 'error'
    })
  }
}

onMounted(() => {
    fetchDescriptions();
})
</script>

<style scoped>
.description-browser {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.description-select-container {
  margin: 20px 0;
}

.description-select {
  width: 100%;
}
</style> 